module.exports = {"511322001":"绥安街道","511322002":"朗池街道","511322003":"城南街道","511322101":"渌井镇","511322102":"东升镇","511322103":"骆市镇","511322104":"黄渡镇","511322105":"小桥镇","511322106":"灵鹫镇","511322107":"老林镇","511322108":"木垭镇","511322109":"消水镇","511322110":"双流镇","511322111":"绿水镇","511322113":"蓼叶镇","511322114":"新店镇","511322115":"回龙镇","511322116":"星火镇","511322117":"西桥镇","511322121":"望龙湖镇","511322122":"青山镇","511322212":"木顶乡","511322216":"明德乡","511322219":"太蓬乡","511322221":"柏林乡","511322225":"悦中乡","511322230":"大庙乡","511322232":"安化乡","511322237":"清水乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511322.json
// module id = 2475
// module chunks = 0